module.exports = __webpack_public_path__ + "img/img02.25ff69fd.png";